(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./Loading.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./Loading.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.Loading);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _Loading) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "button-loading"
      });
    },
    name: 'button-loading',
    props: {}
  };
  _exports.default = _default;
});